export default __webpack_public_path__ + "static/media/gallery_09.63d04697.jpg";